<template>
  <div class="body-login">
    <div class="container">
      <div class="d-flex justify-content-center h-100 w-50 w-50-extended">
        <div class="card card-extended">
          <div class="card-header card-header-style">
            <h1>Hello,</h1>
            <h3>Welcome Back.</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="submitLogin">
              <div class="input-group form-group input-group-expand">
                <input
                  v-model="username"
                  type="text"
                  class="form-control rounded-input"
                  placeholder="Username"
                >
              </div>
              <div class="input-group form-group input-group-expand">
                <input
                  v-model="password"
                  type="password"
                  class="form-control rounded-input"
                  placeholder="Password"
                >
              </div>
              <div class="row remember-me-row">
                <div class="align-items-center remember">
                  <input
                    v-model="rememberMe"
                    type="checkbox"
                  >Remember Me
                </div>
                <div class="forgot-password">
                  Forgot password?
                </div>
              </div>
              <div
                class="my-2 danger-color"
                v-if="haveError"
              >
                <i
                  class="fa fa-exclamation-circle"
                  aria-hidden="true"
                ></i>
                {{ messageError }}
              </div>
              <div class="form-group input-group-expand">

                <input
                  type="submit"
                  value="Login"
                  class="btn float-right login-btn"
                >
              </div>
              <div class="form-group input-group-expand hr-div-style">
                <hr class="hr-style"/>
              </div>
              <div class="form-group input-group-expand">
                <button
                    class="btn login-btn-google"
                    type="button"
                    @click="loginWithFirebase"
                  >
                  <i
                    class="fa fa-google google-multicolor google-icon"
                  ></i>
                  <span class="google-span">Sign in with Google</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      class="text-center text-success my-2 loading-overlay"
      v-show="isLoading"
    >
    <div style="padding-top: 20%">
      <b-spinner
        label="Loading..."
        class="align-middle spinner-size"
      ></b-spinner>
    </div>
    </div>
  </div>
</template>

<script>
import { firebase } from '../../firebase-config';

export default {
  data () {
    return {
      username: '',
      password: '',
      haveError: false,
      messageError: '',
      isLoading: false,
      rememberMe: true
    };
  },
  methods: {
    submitLogin () {
      this.haveError = false;
      this.axios.post(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/login',
        { username: this.username, password: this.password })
        .then(response => {
          this.handleSuccess(response.data.data);
        })
        .catch(error => {
          this.handlerError(error);
        });
    },
    loginWithFirebase () {
      const vm = this;
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
      vm.isLoading = true;
      firebase.auth().signInWithPopup(provider).then(function (result) {
        // success to get idToken
        firebase.auth().currentUser.getIdToken(true)
          .then((token) => {
            vm.axios.post(process.env.VUE_APP_ACCESS_CONTROL_URL + '/firebase-token/verify',
              { token: token })
              .then(response => {
                vm.handleSuccess(response.data.data);
              })
              .catch(error => {
                vm.handlerError(error);
                vm.isLoading = false;
              });
          });
      }).catch((error) => {
        console.log(error);
        vm.isLoading = false;
      }).finally(() => {
      });
    },
    handlerError (error) {
      this.haveError = true;
      this.messageError = error.message;
      if (error.response) {
        this.messageError = error.response.data.message;
      }
    },
    handleSuccess (data) {
      if (!data) {
        throw new Error('access denied ! not found Token.');
      } else {
        const user = JSON.stringify({
          username: data.username,
          fullname: data.fullname,
          permission: data.permission
        });
        if (this.rememberMe) {
          localStorage.setItem('user', user);
          localStorage.setItem('jwt', data.token);
          localStorage.setItem('expire', data.expire);
        } else {
          sessionStorage.setItem('user', user);
          sessionStorage.setItem('jwt', data.token);
          sessionStorage.setItem('expire', data.expire);
        }
        this.isLoading = false;
        const nextUrl = this.$route.params ? this.$route.params.nextUrl ? this.$route.params.nextUrl : null : null;
        if (nextUrl) {
          this.$router.replace({ name: nextUrl });
        } else {
          this.$router.replace({ name: 'home' });
        }
      }
    }
  }
};
</script>

<style scoped>
.danger-color {
  color: #f86c6b;
}
.body-login {
  background-image: url('/images/new/login-bg-full.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  font-family: "Numans", sans-serif;
}

.container {
  height: 100%;
  align-content: center;
}

.card {
  height: 280px;
  margin-top: auto;
  margin-bottom: auto;
  width: 400px;
  border: 0px;
}

.card-header-style {
  padding-bottom: 50px;
}
.card-header-style h1 {
  font-weight: bold;
  font-size: 9vh;
}

.card-header-style h3 {
  font-size: 5vh;
}

.social_icon span {
  font-size: 60px;
  margin-left: 10px;
  color: rgb(22, 25, 27);
}

.social_icon span:hover {
  color: #2494cc;
  cursor: pointer;
}

.card-header{
  color: #3e8b9c;
  background-color: #FFFFFF;
  border-bottom: none;
}

.card-extended {
  margin-top: 20%;
}

.w-50-extended {
  width: 35% !important;
}

.input-group-expand {
  width: 122%;
}

.social_icon {
  position: absolute;
  right: 20px;
  top: -45px;
}

.input-group-prepend span {
  width: 50px;
  background-color: rgb(59, 58, 54);
  color: white;
  border: 0 !important;
}

.rounded-input {
    border-radius: 46px;
    border: 1px solid #4693a4;
    padding: 20px;
    width: 200px;
    /* height: 15px; */
}
.rounded-input::placeholder {
  color: #cbcbcb;
  font-weight: bold;
}

.remember {
  color: #3e8b9c;
  width: 50%;
}

.remember input {
  width: 20px;
  height: 15px;
  margin-left: 19px;
  margin-right: 2px;
}

.forgot-password {
  color: #3e8b9c;
  width: 50%;
  text-align: right;
  padding-right: 15px;
}

.remember-me-row {
  padding-bottom: 21px;
  padding-top: 10px;
  width: 129%;
}

.login-btn {
    border-radius: 25px;
    width: 100%;
    background-color: #339daa;
    color: white;
    vertical-align: middle;
    padding: 11px;
}

.login-btn-google {
    border: 2px solid;
    border-color: #3e8b9c;
    border-radius: 25px;
    color: #3e8b9c;
    width: 100%;
    font-weight: bold;
    vertical-align: middle;
    padding: 10px;
}

hr.hr-style {
    padding: 0;
    border: none;
    border-top: 1px dashed #3e8b9c;
    color: #3e8b9c;
    text-align: center;
}

hr.hr-style:after {
    content: "Or";
    display: inline-block;
    position: relative;
    top: -0.7em;
    font-size: 1em;
    padding: 0 0.2em;
    background: white;
}

.hr-div-style {
  padding-top: 40px;
  padding-bottom: 0.3px;
}

.links {
  color: white;
}

.links a {
  margin-left: 4px;
}

.google-multicolor {
  background-image: url("../assets/google-multicolor.png") !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 60% auto;
}

.fa-google::before {
  content: "\F" !important;
}

.google-login-btn {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.19);
}

.google-login-btn:hover {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 255), 0 0 20px 0 rgba(0, 0, 255, 0.19);
}

.btn-brand {
  bottom: 0;
  border-radius: 0px;
}

.btn-brand i {
  bottom: 0;
  border-radius: 0px;
}

.loading-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: -5px;
    left: 0;
    background: rgba(255,255,255,.3);
}

.spinner-size {
  width: 10rem;
  height: 10rem;
}

.google-button {
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 5px;
  height: 30px;
  /* border: 1px rgb(94, 92, 92) solid; */
  -webkit-box-shadow: 0px 0px 2px 1px rgba(255,255,255,0.45);
  -moz-box-shadow: 0px 0px 2px 1px rgba(255,255,255,0.45);
  box-shadow: 0px 0px 2px 1px rgba(255,255,255,0.45);
}
.google-button:hover{
  -webkit-box-shadow: 0px 0px 5px 1px rgba(255,255,255,1);
  -moz-box-shadow: 0px 0px 5px 1px rgba(255,255,255,1);
  box-shadow: 0px 0px 5px 1px rgba(255,255,255,1);
}

.google-icon {
  height: 20px;
  width: 26px;
}
.google-span {
  position: relative;
}
.google-multicolor {
  background-size: 93% auto !important;
}
/* iPhone X */
@media only screen and (min-width: 375px) and (orientation: portrait) {
  .w-50-extended {
    width: 84% !important;
  }
  .card-extended {
    margin-top: 20%;
  }
 }
/* iPhone X */
 @media only screen and (max-width: 812px) and (min-width: 812px) and (orientation: landscape) {
   .card-extended {
     margin-top: 20px;
   }
   .card-header {
     padding-bottom: 0px;
   }
   .input-group-expand {
     width: 122%;
   }
   .rounded-input {
     padding: 15px;
     height: 9px;
   }
   .remember-me-row {
     padding-bottom: 14px;
     padding-top: 0px;
   }
   .login-btn {
     padding: 3px;
   }
   .hr-div-style {
     padding-top: 8px;
     padding-bottom: 0px;
   }
   .login-btn-google {
     padding: 2px;
   }
   .remember-me-row {
     font-size: small;
   }
   .remember input {
     height: 14px;
   }
  }
  /* iPhone 6/7/8 */
  @media only screen and (max-width: 667px) and (min-width: 667px) and (orientation: landscape) {
      .card-extended {
        margin-top: 20px;
      }
      .card-header {
        padding-bottom: 0px;
      }
      .input-group-expand {
        width: 122%;
      }
      .rounded-input {
        padding: 15px;
        height: 9px;
      }
      .remember-me-row {
        padding-bottom: 14px;
        padding-top: 0px;
      }
      .login-btn {
        padding: 3px;
      }
      .hr-div-style {
        padding-top: 8px;
        padding-bottom: 0px;
      }
      .login-btn-google {
        padding: 2px;
      }
      .remember-me-row {
        font-size: smaller;
      }
      .remember input {
        height: 14px;
      }
      .w-50-extended {
        width: 45% !important;
      }
      .container {
        margin-left: 1px;
      }
   }
    /* iPhone 6/7/8 Plus */
   @media only screen and (max-width: 736px) and (min-width: 736px) and (orientation: landscape) {
      .card-extended {
        margin-top: 20px;
      }
      .card-header {
        padding-bottom: 0px;
      }
      .input-group-expand {
        width: 122%;
      }
      .rounded-input {
        padding: 15px;
        height: 9px;
      }
      .remember-me-row {
        padding-bottom: 14px;
        padding-top: 0px;
      }
      .login-btn {
        padding: 3px;
      }
      .hr-div-style {
        padding-top: 8px;
        padding-bottom: 0px;
      }
      .login-btn-google {
        padding: 2px;
      }
      .remember-me-row {
        font-size: smaller;
      }
      .remember input {
        height: 14px;
      }
      .w-50-extended {
        width: 45% !important;
      }
      .container {
        margin-left: 1px;
      }
   }

    /* iPhone 11 */
   @media only screen and (max-width: 896px) and (min-width: 896px) and (orientation: landscape) {
     .card-extended {
        margin-top: 10%;
      }
      .card-header-style {
          padding-bottom: 6px;
      }
      .rounded-input {
          padding: 15px;
          height: 15px;
      }
      .remember-me-row {
          padding-bottom: 13px;
          padding-top: 0px;
          font-size: small;
      }
      .login-btn {
          padding: 3px;
      }
      .hr-div-style {
          padding-top: 15px;
          padding-bottom: 0px;
      }
      .login-btn-google {
          padding: 3px;
      }
    }

    /* iPad */
   @media only screen and (min-width: 1024px) and (max-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
      .card-extended {
        margin-top: 30%;
      }
   }
    /* iPad Pro */
   @media only screen and (min-width: 1366px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
    .card-extended {
            margin-top: 40%;
    }

  }

</style>
